module.exports = __webpack_public_path__ + "static/IBC-desktop-hero-015ebe35ddf85b1c6fff752589f1af61.jpg";